import React, { useEffect, useRef, useState } from 'react';
import { WindowItem } from '../../../common/interfaces/os-resume-interface';
import styles from './mobile-task-group.module.scss';
import { classnames } from '../../../common/general-utilities/general-utilities';
import { SoundType } from '../../../common/services/systemSoundsService';

interface MobileTaskGroupProps {
  windows: WindowItem[];
  activeId: string | null;
  activateWindow: (id: string) => void;
  closeWindow: (id: string) => void;
  play: (type: SoundType) => void;
}

const MobileTaskGroup: React.FC<MobileTaskGroupProps> = ({
  windows,
  activeId,
  activateWindow,
  closeWindow,
  play,
}) => {
  const [open, setOpen] = useState(false);
  const handleCloseWindow = (id: string) => {
    play('click');
    closeWindow(id);
    setOpen(false);
  };

  const handleWindowTitleClick = (id: string) => {
    play('click');
    activateWindow(id);
    setOpen(false);
  };
  const openWindowListRef = useRef<HTMLDivElement>(null);
  const openWindowButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!open) return;

      const target = event.target as Node;

      if (
        openWindowListRef.current &&
        !openWindowListRef.current.contains(target) &&
        openWindowButtonRef.current &&
        !openWindowButtonRef.current.contains(target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const handleWindowMenuOpenBtn = () => {
    play('click');
    setOpen((p) => !p);
  };

  return (
    <div className={styles.mobileTaskGroup}>
      <button
        className={styles.mobileTaskButton}
        onClick={handleWindowMenuOpenBtn}
        ref={openWindowButtonRef}
      >
        {windows.length} Windows ▼
      </button>

      {open && windows.length > 0 && (
        <div ref={openWindowListRef} className={styles.mobileWindowList}>
          {windows.map((w) => (
            <div
              key={w.id}
              className={classnames(styles.mobileWindowItem, {
                [styles.activeTask]: activeId === w.id && !w.minimized,
              })}
            >
              <div
                className={styles.mobileWindowTitle}
                onClick={() => handleWindowTitleClick(w.id)}
                role='button'
              >
                {w.Icon}
                <span className={styles.title}>{w.title}</span>
              </div>

              <button
                className={styles.mobileCloseBtn}
                onClick={() => handleCloseWindow(w.id)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileTaskGroup;
